import { httpObjQueryString } from "../config/httpClient";
import { setDataParams, SetGateWay } from "./gateway";
import localStorageService from "../../services/localStorageService";

const { httpGateWay } = SetGateWay();
const httpClient = httpGateWay;
export const createBestExpressOrderApi = (order, data) => {
  const localStorage = localStorageService.getService();
  const domain = localStorage.getConfig();
  const orderId = {
    orderId: order,
    address: data.address,
    prefix: domain?.prefix ?? "",
  };
  // console.log(orderId)
  return httpClient.post(`/bestexpress/order/create`, orderId);
};

export const cancelBestExpressOrderApi = (data) => {
  const orderId = {
    orderId: data,
  };
  return httpClient.post(`/bestexpress/order/cancel`, setDataParams(orderId));
};
export const updateBestExpressTrackingOrderApi = (data) => {
  return httpClient.post(
    `/bestexpress/order/tracking/update`,
    setDataParams(data)
  );
};

export const trackingBestExpressOrderApi = (id) => {
  return httpClient.get(`/bestexpress/order/tracking/${id}`);
};

export const printBestExpressOrderApi = (data) => {
  const orderId = {
    orderId: data.orderId,
    type: data.type,
  };
  return httpClient.post(`/bestexpress/order/print`, setDataParams(orderId));
};
